import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export const ProtectedRoute = ({ children }: any) => {
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') as string);
    const loginData = localStorage.getItem('loginData');
    const navigate = useNavigate();
    const currentUrl = window.location.pathname;

     
    
    useEffect(() => {
        if (!isLoggedIn) {

            const redirectTimer = setTimeout(() => {
                if (currentUrl === '/checkout' || currentUrl === '/bookings' || currentUrl === '/profile') {                    
                    navigate('/login', { replace: true });
                }else{
                    navigate('/admin', { replace: true });
                }                
            }, 400); // Redirect after 3 seconds

            return () => clearTimeout(redirectTimer);
        }
    }, [isLoggedIn, navigate]);

    return isLoggedIn ? children : <div>Unauthorized access. Redirecting to login...</div>;
};